var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { isNotNullOrEmpty, isString } from '@pcty/utils';
import { getAutomation } from '@citrus/runtime';
import { ZeroStateMessage } from '../ZeroState.styled';
var Message = function (_a) {
    var type = _a.type, message = _a.message, automationId = _a.automationId, lang = _a.lang;
    if (isNotNullOrEmpty(message) && isString(message)) {
        return React.createElement(ZeroStateMessage, __assign({}, getAutomation(automationId, 'message')), message);
    }
    return isNotNullOrEmpty(lang[type]) ? (React.createElement(ZeroStateMessage, __assign({}, getAutomation(automationId, 'message')), lang[type])) : (React.createElement(React.Fragment, null));
};
export default Message;
